import { AxiosInstancePlus } from '@tencent/oneid-request';
import { ACCOUNT_TYPE } from 'common/constants/Constants';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';
import type { ICaptchaReportParams } from 'common/utils/captchaRequest';
import captchaRequest from 'common/utils/captchaRequest';
import { ILoginByMobile, ISendMfaSmsResponse } from '../type';

export interface ICreateAccount {
  /** 企业名 */
  company_name: string;
  /** 创建人名 */
  name: string;
  /** 行业类型 */
  industry_type: string;
  /** 企业类型： 1. 企业 2. 个人 */
  account_type?: ACCOUNT_TYPE;
  [key: string]: any;
}

class UserApi {
  public axiosInstance: AxiosInstancePlus = http;

  public prefixURL = '/user/v1';

  /**
   * 发送验证码
   * @param mobile 手机号
   * @description 先弹出滑块验证，再发送验证码
   */
  sendVerificationCode(
    mobile: string,
    reportParams?: ICaptchaReportParams,
  ): Promise<IResponseType<ISendMfaSmsResponse>> {
    return captchaRequest(
      (captchaVerification) =>
        this.axiosInstance.post(
          `${this.prefixURL}/user/signup/sms:send`,
          {
            mobile,
            captchaVerification,
          },
          { skipShowError: true },
        ),
      reportParams,
    );
  }

  /**
   * 注册码验证
   */
  registerByCode(params: {
    verificationSessionId: string;
    verificationCode: string;
    app?: string;
  }): Promise<IResponseType<ILoginByMobile>> {
    return captchaRequest((captchaVerification) =>
      this.axiosInstance.post(
        `${this.prefixURL}/user/signup`,
        {
          ...params,
          captchaVerification,
        },
        { skipShowError: true },
      ),
    );
  }

  /**
   * 创建企业
   * @param data 企业信息
   */
  createAccount(data: ICreateAccount): Promise<IResponseType> {
    return this.axiosInstance.post(`${this.prefixURL}/accounts`, data, { skipShowError: true });
  }
}
export default new UserApi();
